import React from 'react';
import { IconProps } from './types';

const DeleteIcon: React.FC<IconProps> = props => {
  const { className, size = 16, onClick, fillColor = '#969696' } = props;
  return (
    <svg
      onClick={onClick}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_12577_140163"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12577_140163)">
        <path
          d="M4.66699 14C4.30033 14 3.98655 13.8696 3.72566 13.6087C3.46433 13.3473 3.33366 13.0333 3.33366 12.6667V4C3.14477 4 2.98633 3.93622 2.85833 3.80867C2.73077 3.68067 2.66699 3.52222 2.66699 3.33333C2.66699 3.14444 2.73077 2.986 2.85833 2.858C2.98633 2.73044 3.14477 2.66667 3.33366 2.66667H6.00033C6.00033 2.47778 6.06433 2.31933 6.19233 2.19133C6.31988 2.06378 6.4781 2 6.66699 2H9.33366C9.52255 2 9.68099 2.06378 9.80899 2.19133C9.93655 2.31933 10.0003 2.47778 10.0003 2.66667H12.667C12.8559 2.66667 13.0141 2.73044 13.1417 2.858C13.2697 2.986 13.3337 3.14444 13.3337 3.33333C13.3337 3.52222 13.2697 3.68067 13.1417 3.80867C13.0141 3.93622 12.8559 4 12.667 4V12.6667C12.667 13.0333 12.5365 13.3473 12.2757 13.6087C12.0143 13.8696 11.7003 14 11.3337 14H4.66699ZM4.66699 4V12.6667H11.3337V4H4.66699ZM6.00033 10.6667C6.00033 10.8556 6.06433 11.0138 6.19233 11.1413C6.31988 11.2693 6.4781 11.3333 6.66699 11.3333C6.85588 11.3333 7.01433 11.2693 7.14233 11.1413C7.26988 11.0138 7.33366 10.8556 7.33366 10.6667V6C7.33366 5.81111 7.26988 5.65267 7.14233 5.52467C7.01433 5.39711 6.85588 5.33333 6.66699 5.33333C6.4781 5.33333 6.31988 5.39711 6.19233 5.52467C6.06433 5.65267 6.00033 5.81111 6.00033 6V10.6667ZM8.66699 10.6667C8.66699 10.8556 8.73099 11.0138 8.85899 11.1413C8.98655 11.2693 9.14477 11.3333 9.33366 11.3333C9.52255 11.3333 9.68099 11.2693 9.80899 11.1413C9.93655 11.0138 10.0003 10.8556 10.0003 10.6667V6C10.0003 5.81111 9.93655 5.65267 9.80899 5.52467C9.68099 5.39711 9.52255 5.33333 9.33366 5.33333C9.14477 5.33333 8.98655 5.39711 8.85899 5.52467C8.73099 5.65267 8.66699 5.81111 8.66699 6V10.6667Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default DeleteIcon;
